import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";

interface RateSourceSelectionWarningProps {
  description: string;
  title: string;
}

export function RateSourceSelectionWarning({
  description,
  title,
}: RateSourceSelectionWarningProps) {
  return (
    <Flex
      bgColor="warning-primary"
      borderColor="fg-warning-secondary"
      borderRadius="md"
      borderStyle="solid"
      borderWidth="1px"
      dir="column"
      gap="xxs"
      p="md"
      w="full"
    >
      <Text fontSize="xs" fontWeight="semibold" textColor="warning">
        {title}
      </Text>
      <Text fontSize="xs" fontWeight="regular" textColor="warning">
        {description}
      </Text>
    </Flex>
  );
}
